import styled from 'styled-components';

export const StyledHeader = styled.div<{ $ghost?: boolean }>`
  padding: 16px;
  border-bottom: ${({ $ghost, theme }) =>
    $ghost ? 'none' : `1px solid ${theme.token.next.colorBorder}`};
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
`;

export const StyledBody = styled.div<{ $noPadding?: boolean }>`
  padding: ${({ $noPadding }) => ($noPadding ? 0 : '16px')};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledFooter = styled.div<{ $ghost?: boolean }>`
  padding: 16px;
  border-top: ${({ $ghost, theme }) =>
    $ghost ? 'none' : `1px solid ${theme.token.next.colorBorder}`};
  display: flex;
  justify-content: flex-end;
`;
